import Feeling from "./Feeling";
import GoHomeTimer from "./GoHomeTimer";
import Header from "./Header";
import "./PostFeeling.css"
import { Screen, usePodContext } from "../PodContext";
import { useNavigate } from "react-router";
import mixpanel from "mixpanel-browser";
import Footer from "./Footer";
import SkipButton from "./SkipButton";

const PostFeeling = () => {
  const { preFeeling, scene, audio, setPostFeeling } = usePodContext()
  const navigate = useNavigate()

  const selected = (choice: number) => {
    setPostFeeling(choice)

    mixpanel.track("Meditation Complete", {
      preFeeling,
      scene: scene.title,
      audio: audio.name,
      postFeeling: choice,
      moodChange: choice - preFeeling,
      moodChangePercent: (choice - preFeeling) / preFeeling
    })

    navigate(Screen.FINISHED)
  }

  return (
    <div className="image-bg-container">
      <GoHomeTimer />
      <Header totalSteps={3} title="Tell us about your experience" noBack progress={1} />
      <div className="vr-post-feeling-container">
        <Feeling selected={selected} />
      </div>
      <Footer />
      <SkipButton handleClick={() => navigate(Screen.FINISHED)} text="Skip"/>
    </div>
  )
}

export default PostFeeling;